import React, {useMemo} from 'react';
import { fetchStudioAudio } from "../../api/studio-api";
import styles from './AudioPlayer.module.scss';
import Spinner from "../Spinner";
import ReactPlayer from 'react-h5-audio-player';
import { ReactComponent as PlayIcon } from '../../img/icons/play-icon-active.svg';
import { ReactComponent as PauseIcon } from '../../img/icons/player-pause-icon.svg';
import { useDispatch, useSelector } from "react-redux";
import { playerSelector } from "../../redux/modules/player/player-selectors";
import { setCurrentPlayer } from "../../redux/modules/player/player-actions";
import {STUDIO_ENTITY} from "../../constants/studioEntities";

const AudioPlayer = ({
     trackId,
     entityName,
     setAudioUrl,
     compactMode,
     onPlayStart
 }) => {
    const playerRef = React.useRef(null);
    const currentPlayer = useSelector(playerSelector);
    const dispatch = useDispatch();

    const [audioSrc, setAudioSrc] = React.useState(null);
    const [isLoading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    const localEntityName = useMemo(() => {
        if (entityName === STUDIO_ENTITY.ARCHIVE) {
            return STUDIO_ENTITY.RECORDS;
        }

        return entityName
    }, [entityName]);

    React.useEffect(() => {
        const fetchAudio = async () => {
            try {
                const {data: audio} = await fetchStudioAudio(trackId, localEntityName);

                const audioObjectUrl = URL.createObjectURL(new Blob([audio], {type: 'audio/mpeg'}));
                setAudioSrc(audioObjectUrl);
                setAudioUrl && setAudioUrl(audioObjectUrl);
            } catch (e) {
                if (e.response && e.response.data) {
                    setError(e.response.data.errorMessage);
                } else {
                    console.error(e);
                }
            }
            setLoading(false);
        }

        fetchAudio();
    }, [trackId, localEntityName, setAudioUrl]);

    const onPlay = () => {
        dispatch(setCurrentPlayer(audioSrc));
        if (onPlayStart) {
            onPlayStart();
        }
    };

    React.useEffect(() => {
        if (currentPlayer && (audioSrc !== currentPlayer)) {
            playerRef.current && playerRef.current.audio.current.pause();
        }
    }, [audioSrc, currentPlayer])

    if (isLoading) {
        return (
            <div className={styles.playerLoading}>
                <Spinner/>
            </div>
        )
    }

    return (
        <div className={styles.playerContainer}>
            {error ?
                (
                    <div className={styles.error}>
                        {error}
                    </div>
                ) : (
                    <ReactPlayer
                        ref={playerRef}
                        showSkipControls={false}
                        showJumpControls={false}
                        autoPlayAfterSrcChange={false}
                        customVolumeControls={[]}
                        customAdditionalControls={[]}
                        customProgressBarSection={compactMode ? [] : undefined}
                        customIcons={{
                            play: <PlayIcon />,
                            pause: <PauseIcon />
                        }}
                        layout={compactMode ? "horizontal" : "horizontal-reverse"}
                        src={audioSrc}
                        onPlay={onPlay}
                    />
                )}
        </div>
    );
};

export default AudioPlayer;
